import { InjectionToken } from '@angular/core';
import { MAT_CHECKBOX_DEFAULT_OPTIONS } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { AppInitService } from '../digigov/services/app-init.service';
export const CustomConfig = {
  height: '200px',
};
/* export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    dateA11yLabel: 'LL',
    monthYearLabel: 'MMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}; */
export const APP_CONFIG = new InjectionToken('app.config');
export const ComponentConfig = [
  {
    provide: MAT_DATE_LOCALE,
    useFactory: (appInit: AppInitService) => {
      return appInit?.appConfig?.defaultFormats?.['date-locale']
        ? appInit?.appConfig?.defaultFormats?.['date-locale']
        : 'en-US';
    },
    deps: [AppInitService],
  },
  // { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  // For PFML
  {
    provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
    useValue: {
      floatLabel: 'always',
      appearance: 'unset',
    },
  },
  { provide: APP_CONFIG, useValue: CustomConfig },
  { provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
  { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { color: 'primary' } },
];
